import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { initAuth } from '@/lib/auth/useAuth'

// Order matters: tokens first, then element defaults, then the handful of
// global shapes pages opt into with a class (status lines, record forms,
// data tables). Everything else is scoped to its component.
import '@/styles/tokens.css'
import '@/styles/base.css'
import '@/styles/page.css'
import '@/styles/table.css'
import '@/styles/form.css'
import { initCountries } from '@/lib/countries'

// Kick the session restore off before the first navigation is resolved.
void initAuth()

// Reference data, fetched once and shared. See lib/countries.ts.
void initCountries()

createApp(App).use(router).mount('#app')
